import { render, staticRenderFns } from "./GBService.vue?vue&type=template&id=f0abf71a&"
import script from "./GBService.vue?vue&type=script&lang=js&"
export * from "./GBService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports